export enum EditFormKeys {
    StatusComment = 'statusComment',
}
